import { fetcher } from "helpers/fetcher";

import { TGetJobListingListReq, TGetJobListingListRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getJobListingList = async (params?: TGetJobListingListReq) => {
  return await fetcher<TGetJobListingListRes, TGetJobListingListReq["data"]>(
    ENDPOINT.CORPORATION.GET_JOB_LISTING_LIST,
    {
      params: params?.data,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.CORPORATION.GET_JOB_LISTING_LIST.version,
        [API_HEADER.CORP_ID]: params?.idCorp,
      },
    }
  );
};

export const queryGetJobListingList = async (
  params?: TGetJobListingListReq
) => {
  return (await getJobListingList(params)).data;
};

queryGetJobListingList._key = (
  params?: TGetJobListingListReq,
  key?: number
) => [ENDPOINT.CORPORATION.GET_JOB_LISTING_LIST.url, params, key];
